// src/pages/ManageAdsAndPropertiesPage.js

import React from 'react';
import { Box, Typography } from '@mui/material';

const ManageAdsAndPropertiesPage = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        Manejar Anuncio + Propiedad
      </Typography>
      <Typography variant="body1">
        Esta página permite que você gerencie anúncios e propiedades.
      </Typography>
    </Box>
  );
};

export default ManageAdsAndPropertiesPage;
